import { text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class RetailerPayType extends BaseModel {
  static table = "retailer_pay_types";
  @text("pay_code") payCode: string | null;
  @text("pay_description") payDescription: string | null;
}
